import styled, { css } from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2rem;

    p{
        font-weight: 500;
        font-size: 1.2rem;
        margin: 0 1rem 1rem 1rem;
    }

    input{
        background: #7A05A7;
        padding: 0.7rem;
        color: #FFF;
        border: none;
        outline: none;
        font-weight: 500;
        font-size: 1rem;
        border-radius: 0.25rem;
        position: relative;
        margin-bottom: 1rem;
        flex: auto;
    }

    input::-webkit-calendar-picker-indicator {
        color: transparent;
        background: none;
        z-index: 1;
        
        @media (min-width: 960px){
            cursor: pointer;
        }
    }

    input:before {
        color: transparent;
        background: none;
        display: block;
        font-family: 'material icons';
        content: 'date_range';
        width: 1rem;
        position: absolute;
        top: 50%;
        right: 6px;
        color: #FFF;
        transform: translateY(-50%);
    }

    .endDate{
        ${props => props.noEndDate && css`
            pointer-events: none;
            opacity: 0.5;
        `}
    }

    @media (max-width: 480px){
        justify-content: center;
        flex-direction: column;
    }
`